exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tip-info {\n  padding: 8px 16px;\n  background-color: #fff6f7;\n  border-radius: 4px;\n  border-left: 5px solid #ff7800;\n  margin: 11px 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-568c3e6e","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/brand/wechat/aterialmanagement.vue
// module id = 1487
// module chunks = 0